<aside class="esf-main-sidebar esf-main-sidebar--working-space -has-transition"
       [ngClass]="{'-is-open': clubOverviewService.listOfModals.createWebhookModal}">
  <div class="esf-main-sidebar__content">
    <h3 i18n='Attributes edit modal title@@clubOverview.workspace.createWebhook'>Create webhook</h3>
    <form [formGroup]="clubForm" (ngSubmit)="updateClub()" id="webhookForm">
      <div class="esf-form-item esf-form-validation">
        <label for="name" class="esf-form-item__label" i18n='Form label text@@general.formLabel.name'>Name</label>
        <div class="esf-select">
          <select class="esf-form-item__field esf-select__field selected-field" id="name" autocomplete="off" formControlName="name">
            <option [value]="'customer'"
                    i18n='Form option@@general.formOption.customer'
                    [hidden]="selectedClub.webhookExists('customer')">Customer</option>
            <option [value]="'invoice'"
                    i18n='Form option@@general.formOption.invoice'
                    [hidden]="selectedClub.webhookExists('invoice')">Invoice</option>
          </select>
        </div>
      </div>
    </form>
  </div>

</aside>

<div class="esf-main-sidebar--working-space__actions -has-transition -is-open">
    <app-submit-row-buttons [form]="'webhookForm'"
                            [cancelButtonText]="buttonsTranslations.i18nBack"
                            [submitButtonText]="buttonsTranslations.i18nSubmit"
                            [spinnerName]="spinnerName"
                            (cancelButton)="clubOverviewService.toggleAllModal(false)">
    </app-submit-row-buttons>
  </div>

<div class="esf-hamburger esf-hamburger--working-space esf-js-workingSpaceToggle -has-transition"
     [ngClass]="{'-is-open': clubOverviewService.listOfModals.createWebhookModal }" (click)="clubOverviewService.toggleAllModal(false)">
  <span class="esf-hamburger__icon"></span>
</div>
